import React from 'react';
import Markdown from 'react-markdown';

const Card = ({ card }) => (
  <div className={`window active card card-${card.type || 'memory'}`}>
    <div className="title-bar card-type">
      <div className="title-bar-text">
        {card.type && `${card.type} - `}{card.name}
      </div>
      <div className="title-bar-controls">
        <button aria-label="Minimize"></button>
        <button aria-label="Maximize"></button>
        <button aria-label="Close"></button>
      </div>
    </div>
    <div className="window-body has-space">
      { card.imageUrl !== undefined && <img src={card.imageUrl} alt={card.name} className="card-image" /> }
      <p className="card-description">
        <Markdown>{card.description}</Markdown>
      </p>
      { card.author !== undefined && <p className="card-author">-- {card.author}</p> }
      { card.tags !== undefined && card.tags.length > 0 &&
        <div className="combobox">
          <ul role="listbox" className="card-tags">
            {card.tags.map((tag, index) => (
              
              <li key={index} className="" role="option">
                {tag}
              </li>
            ))}
          </ul>
        </div>
      }
    </div>
  </div>
);

export default Card;